import React, { useState, useEffect } from "react";
// Components
import Preloader from "../../../components/Preloader/Preloader";
import MessageBox from "../../../components/MessageBox/MessageBox";
import { Redirect } from "react-router-dom";
import axios from "axios";
import { Clear, LoyaltyTwoTone } from "@material-ui/icons";
import Grid from "@material-ui/core/Grid";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import TextField from "@material-ui/core/TextField";
import Select from "@material-ui/core/Select";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { makeStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import { format } from "date-fns";
import DateFnsUtils from "@date-io/date-fns";
import Breadcrumbs from "@material-ui/core/Breadcrumbs";
import Typography from "@material-ui/core/Typography";
import { get_cookies, isLoggedIn, timeZoneChanger } from "../../../components/Cookies/Cookies";
import Input from '@material-ui/core/Input';
import {
	MuiPickersUtilsProvider,
	KeyboardTimePicker,
	KeyboardDatePicker
} from "@material-ui/pickers";
import { NavLink } from "react-router-dom";

const useStyles = makeStyles({
	title: {
		marginTop: 0
	},
	field: {
		width: "100%",
		marginBottom: "1rem"
	},
	autoComplete: {
		width: "100%",
		marginTop: "0",
		marginBottom: "0.5rem"
	},
	date: {
		width: "100%",
		marginBottom: "1rem"
	},
	buttonContainer: {
		textAlign: "right"
	}
});

const PackageSalesSetPackage = props => {
	const classes = useStyles();
	const packagesales_home = {
		pathname: "/package-sales"
	};
	const gobacktoHomepage = () => {
		props.history.push(packagesales_home);
	};
	const navid = props.match.params.navid;
	const CurrentPage = props.match.params.navname;

	//ApiData Component Content Variables
	const [location_dropdown, loadLocationDropdown] = useState([]);
	const [branchIdNo, setBranchIdNo] = useState(get_cookies('branchidno'));
	const [branchCurcode, setBranchCurcode] = useState(get_cookies('curcode'));
	const [shipping_dropdown, loadShippingDropdown] = useState([]);
	const [team_dropdown, loadTeamDropdown] = useState([]);
	const [isLoaded, setisLoaded] = useState();
	const [isFranchise, setIsFranchise] = useState(false);
	const [nextPagePath, setnextPagePath] = useState("");
	const [shippingChargeVal, setShippingChargeVal] = useState(0);
	const [activationLoadFunction, setActivationLoadFunction] = useState("");
	const [activationcardsList, setActivationCardsList] = useState("");
	//Message Box
	const [showMsgBox, setShowMsgBox] = useState(false);
	const [msgBoxContent, setMsg] = useState("Empty");
	const [msgType, setMsgType] = useState("success");
	const [selectedDate, setSelectedDate] = React.useState("");
	//Message Box EOF
	const headers = {
        'Content-Type': 'multipart/form-data',
        'Access-Control-Allow-Origin': process.env.REACT_APP_API_URL,
    };
	//OnLoad Event/Data Fetching
	useEffect(() => {
		isLoggedIn();
		setisLoaded(false);
		get_activationloadfunction();
		check_if_codesonly();
		// setisLoaded(true);
		const newData = { ...prep_data };
		const date = timeZoneChanger();       // get the date string

		newData["trandate"] = date;
		setSelectedDate(date);   
		newData["shippingcharge"] = 0;
		setData({ ...newData });

	}, []);
	// useEffect(() => {
	// 	if(activationLoadFunction != ""){
	// 		load_activationcards();	
	// 	}
	// }, [activationLoadFunction]);
	
	// Api Functions SOF
	const get_activationloadfunction = () => {
		const apiUrl = process.env.REACT_APP_API_URL + "activationload_promo";
		const form_data = {
			navid: navid,
			branchidno:get_cookies('branchidno')
		};
		const formData = new FormData();
		formData.append('form_data', JSON.stringify(form_data));
		axios.post(apiUrl, formData, {headers:headers}).then(res => {
			setisLoaded(true);
			setActivationCardsList(res.data.unusedactivationcards);
		});
	};

	// const load_activationcards = () => {
	// 	const apiUrl = process.env.REACT_APP_API_URL + activationLoadFunction;
	// 	const form_data = {
	// 		navid:navid,
	// 		branchidno:branchIdNo
	// 	};
	// 	const formData = new FormData();
	// 	formData.append('form_data', JSON.stringify(form_data));
	// 	axios.post(apiUrl, formData, {headers:headers}).then(res => {
	// 		setActivationCardsList(res.data.unusedactivationcards);
	// 	});
	// };

	const check_if_franchise = () => {
		const apiUrl = process.env.REACT_APP_API_URL + "get_nav_details";
		const form_data = {
			navid: navid,
			curcode: branchCurcode
		}
		const formData = new FormData();
		formData.append('form_data', JSON.stringify(form_data));
		axios.post(apiUrl, formData, {headers:headers}).then((res) => {
			if(res.data.success > 0){
				if(res.data.package_details.products > 0){
					required_fields.push('sponsor_id');
					setIsFranchise(true);
				} else {
					setIsFranchise(false);
				}
			} else {
				setShowMsgBox(true);
				setMsg("Missing Navigation ID");
				setMsgType("warning");
				setTimeout(() => {
					setShowMsgBox(false);
				}, 3000);
			}
		});
	};

	const validate_sponsor = () => {
		const apiUrl = process.env.REACT_APP_API_URL + "check_sponsor";
		const form_data = {
			sponsor_id: prep_data.sponsor_id
		};
		const formData = new FormData();
		formData.append('form_data', JSON.stringify(form_data));
		axios.post(apiUrl, formData, {headers:headers}).then(res => {
			if (res.data.success > 0) {
				props.history.push(nextpage);
			} else {
				setShowMsgBox(true);
				setMsg("Invalid Sponsor ID");
				setMsgType("warning");
				setTimeout(() => {
					setShowMsgBox(false);
				}, 3000);
			}
		});
	};
	const check_if_codesonly = () => {
		const apiUrl = process.env.REACT_APP_API_URL + "is_codesonly";
		const form_data = {
			navid: navid
		};
		const formData = new FormData();
		formData.append('form_data', JSON.stringify(form_data));
		axios.post(apiUrl, formData, {headers:headers}).then(res => {
			if (res.data.success == 1) {
				setnextPagePath(res.data.nextpagepath);
			} else {
				setShowMsgBox(true);
				setMsg("Missing navigation ID");
				setMsgType("warning");
				setTimeout(() => {
					setShowMsgBox(false);
				}, 3000);
			}
		});
	};

	const validate_required = () => {
		const apiUrl = process.env.REACT_APP_API_URL + "validate_required";
		const form_data = {
			required_fields: required_fields,
			reqfield_obj: prep_data
		};
		const formData = new FormData();

		formData.append('form_data', JSON.stringify(form_data));

		axios.post(apiUrl, formData, {headers:headers}).then(res => {
	
			if (res.data.result.success == 1) {
				props.history.push(nextpage);
			} else {
				setShowMsgBox(true);
				setMsg(res.data.result.message);
				setMsgType("warning");
				setTimeout(() => {
					setShowMsgBox(false);
				}, 3000);
			}
		});
	};
	//Api Request Functions EOF
	const activationcardslist = {
		options: activationcardsList,
		getOptionLabel: (option) => option.idno + "("+option.atype+")",
	};
	
	// useEffect(() => {
	// 	console.log('tte',selectedDate);
	// 	const newData = { ...prep_data };
	// 	// newData["trandate"] = formatDate(selectedDate);
	// 	newData["shippingcharge"] = 0;
	// 	setData({ ...newData });
	// }, []);
	//FormData SOF
	const [prep_data, setData] = useState({});

	const onInputChange = event => {
		const newData = { ...prep_data };
		newData[event.target.name] = event.target.value;
		setData({ ...newData });
	};
	const onInputChangeShipping = event => {
		var regex = /^[0-9!@#\$%\^\&*\\(+=._-]+$/g;			
		let x = "";
		if(regex.test(event.target.value)){
			x = event.target.value;
		}else{
			x = "";
		}
		const newData = { ...prep_data };
		newData[event.target.name] = x;
		setData({ ...newData });
		setShippingChargeVal(x);
		;
	};
	const NumberKeyTrapper = (e) => {
        var a = [];
        var k = e.which;
        
        for (let i = 48; i < 58; i++){
            a.push(i);
        }    
        
        if (!(a.indexOf(k)>=0)){
            e.preventDefault();
        }
    }
	const formatDate = date => {
		let d = new Date(date),
			month = "" + (d.getMonth() + 1),
			day = "" + d.getDate(),
			year = d.getFullYear();

		if (month.length < 2) month = "0" + month;
		if (day.length < 2) day = "0" + day;

		return [year, month, day].join("-");
	};
	const required_fields = [
		"trandate",
		"soldto",
		"refcode",
		"activationcode"
	];
	const numericOnly = (e) =>{
		const re = /^[0-9\b]+$/;
	
		// if value is not blank, then test the regex
		if (e.target.value === '' || re.test(e.target.value)) {
			const newData = {...prep_data};
			newData[e.target.name]= e.target.value;
			setData({ ...newData });
		}
	}
	//FormData EOF
	//FormData Validation SOF
	const nextpage = {
		// pathname: "/package-sales-information",
		pathname: nextPagePath,
		transactionInfo: prep_data, // your data array of objects
		pageInfo: {
			navid: navid,
			navname: CurrentPage
		}
	};

	//FormData Validation EOF
	return (
		<div className="page">
			<div className="page-header">
				<div className="page-icon">
					<LoyaltyTwoTone />
				</div>
				<Breadcrumbs aria-label="breadcrumb">
					<NavLink to="/package-sales">
						<h4 className="header-title">Package Sales</h4>
					</NavLink>
					<Typography color="textPrimary">{CurrentPage}</Typography>
				</Breadcrumbs>
			</div>
			<div className="page-container">
				{}
				{!isLoaded ? (
					<Preloader />
				) : (
					<form noValidate autoComplete="off">
						<MessageBox
							in={showMsgBox}
							content={msgBoxContent}
							type={msgType}
						/>
						<Grid
							container
							spacing={3}
							alignItems="center"
							justify="center"
						>
							<Grid item xs="12" sm="6">
								<Card>
									<CardContent>
										<h4 className={classes.title}>
											Transaction Information
										</h4>
										<MuiPickersUtilsProvider
											utils={DateFnsUtils}
										>
											<KeyboardDatePicker
												disableToolbar
												variant="inline"
												format="MM/dd/yyyy"
												name="trandate"
												label="Date"
												value={selectedDate}
												inputVariant="outlined"
												margin="normal"
												disabled="true"
												required="true"
												className={classes.date}
												onChange={onInputChange}
												KeyboardButtonProps={{
													"aria-label": "change date"
												}}
											/>
										</MuiPickersUtilsProvider>
										<TextField
											name="soldto"
											label="Sold To"
											variant="outlined"
											type="text"
											margin="normal"
											required="true"
											className={classes.field}
											onChange={onInputChange}
										/>
										<TextField
											name="refcode"
											label="Reference Code"
											variant="outlined"
											type="text"
											margin="normal"
											required="true"
											className={classes.field}
											onChange={onInputChange}
										/>
										<Autocomplete
											{...activationcardslist}
											autoComplete
											includeInputInList
											className={classes.autoComplete}
											name="activationcode"
											renderInput={(params) => (
												<TextField
													{...params}
													margin="normal"
													label="Activation Code"	
													variant="outlined"
													required="true"
												/>
											)}
											onChange={(event, newValue) => {
												if (!newValue == "" || !newValue == null){
													const newData = {...prep_data};
													newData['activationcode']= newValue.idno;
													setData({ ...newData });
												}else{
													const newData = {...prep_data};
													newData['activationcode']= "";
													setData({ ...newData });
												}
											}}
										/>
										{!isFranchise ? (
											""
										) : (
											<TextField
												name="sponsor_id"
												label="Sponsor ID"
												variant="outlined"
												type="text"
												margin="normal"
												required="true"
												className={classes.field}
												onChange={onInputChange}
											/>
										)}
										<TextField
											name="shippingcharge"
											label="Shipping Charge"
											variant="outlined"
											margin="normal"
											type="number"
											inputProps={{ min: 0, max: 10 }}
											step={0.5}
											value={shippingChargeVal && Math.max(0, shippingChargeVal)}
											className={classes.field}
											onChange={onInputChangeShipping}
											onKeyPress={NumberKeyTrapper}
										/>
									</CardContent>
								</Card>
							</Grid>
							<Grid
								item
								xs="12"
								className={classes.buttonContainer}
							>
								<Button
									variant="contained"
									color="primary"
									onClick={e => {
										validate_required();
									}}
								>
									Next
								</Button>
							</Grid>
						</Grid>
					</form>
				)}
			</div>
		</div>
	);
};
export default PackageSalesSetPackage;
